<template>
    <main class="wrapper">
        <RouterView/>
    </main>
</template>

<script>

export default {
    name: 'Main'
}
</script>
